import { useMutation } from "@tanstack/react-query";

import { httpClient } from "@/lib/http";
import { HttpResponse, ResetPasswordRequest } from "@/types";

export function useResetPassword() {
  const mutation = useMutation({
    mutationFn: async ({
      resetPasswordRequest,
    }: {
      resetPasswordRequest: ResetPasswordRequest;
    }) => {
      const path = `auth/resetPassword`;
      const res = await httpClient.post<
        // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
        void,
        HttpResponse<void>,
        ResetPasswordRequest
      >(path, resetPasswordRequest);

      return res.data;
    },
  });

  return mutation;
}
